$(document).ready(function() {
    var input = $('input.presskit-filter');
    var container = input.closest('.presskit-container');
    var itemContainer = container.find('.presskit-items-container');
    var noResultContainer = container.find('.presskit-no-result-container');

    var rawItems = container.find('.presskit-item:not(.presskit-item-dummy)');
    var items = $.map(rawItems, function (item, i) {
        return {
            el: $(item),
            text: $(item).find('.presskit-title').text()
        };
    });

    var visibleItemsCount = items.length;

    $('.presskit-filter-clear').click(function() {
        input.val('').keyup();
    });

    input.keyup(function() {
        var text = $(this).val();
        visibleItemsCount = 0;

        if (text.length) {
            $.each(items, function (k, v) {
                if (v.text.indexOf(text) === -1) {
                    v.el.hide();
                } else {
                    v.el.show();
                    visibleItemsCount++;
                }
            });
        } else {
            $.each(items, function (k, v) {
                v.el.show();
            });

            visibleItemsCount = true;
        }

        if (visibleItemsCount === 0) {
            itemContainer.hide();
            noResultContainer.show();
        } else {
            itemContainer.show();
            noResultContainer.hide();
        }
    });
});

function panelPackage() {
    var items = $('table#product-list tbody tr');
    var filterTitle = $('#filter-title');
    var filterSelect = $('.filters-grid select');
    var alerts = $('#panel-package .alerts');
    var counter = $('#panel-package .submit-box .count');

    var selectVisibleButton = $('#select-visible');

    var ids = {};

    function updateSelectVisibleButtonLabel(selected) {
        if (selected === undefined) {
            selected = items.filter(':visible:not(.active)').length > 0;
        }

        if (selected === false) {
            selectVisibleButton.text(selectVisibleButton.data('deselectLabel'));
        } else {
            selectVisibleButton.text(selectVisibleButton.data('selectLabel'));
        }
    }

    //create filter map
    items.each(function() {
        var product = $(this).data('id');
        $.each(String($(this).data('filter')).split(','), function(k, id) {
            if (!ids[id]) {
                ids[id] = [];
            }

            ids[id].push(product);
        });
    });

    $(document).ready(function() {
        $('#product-list').tablesorter();

        //arrows sorting
        $('i[data-sort]').click(function(e) {
            e.preventDefault();

            var direction = $(this).data('sort') === 'up' ? 0 : 1;
            var column = $(this).parents('th').index();

            $('#product-list').trigger('sorton', [
                [
                    [column, direction]
                ]
            ]);
        });

        //picking items
        $('#panel-package tbody tr .add-cell button').click(function () {
            var row = $(this).parent().parent();
            var checkbox = row.find('input[type="checkbox"]');

            if (checkbox.prop('checked')) {
                row.removeClass('active');
                checkbox.prop('checked', false);
                updateCount(-1, true);
                updateSelectVisibleButtonLabel();
            } else {
                row.addClass('active');
                checkbox.prop('checked', true);
                updateCount(1, true);
                updateSelectVisibleButtonLabel();
            }
        });

        selectVisibleButton.click(function(e) {
            e.preventDefault();

            var visible = items.filter(':visible');
            var unchecked = visible.filter(':not(.active)');

            if (unchecked.length > 0) {
                unchecked.addClass('active');
                unchecked.find('input[type="checkbox"]').prop('checked', true);

                updateCount(unchecked.length, true);
                updateSelectVisibleButtonLabel(false);
            } else {
                visible.removeClass('active');
                visible.find('input[type="checkbox"]').prop('checked', false);

                updateCount(visible.length * -1, true);
                updateSelectVisibleButtonLabel(true);
            }
        });

        //filters trigger
        filterSelect.change(function() {
            filterProducts();
        });

        filterTitle.on('input', function() {
            filterProducts();
        });

        //generation ajax
        $('#create-zip-form').submit(function(e) {
            e.preventDefault();

            var items = [];
            var btn = $('#create-zip-submit');
            var alert;
            var locale = $(this).data('locale');
            var email = $(this).find('input[type=email]').val();
            var emailErrors = $(this).find('#email-errors');
            var modal = $('#create-zip-modal');

            btn.prop('disabled', true);
            emailErrors.text('');

            $('#product-list input[type="checkbox"]:checked').each(function() {
                items.push($(this).val());
            });

            $
                .post(
                    Routing.generate('app_press_create'),
                    {
                        items: items,
                        locale: locale,
                        email: email,
                    },
                    function (data) {
                        if (data.status === 'OK') {
                            alert = 'success';

                            $('#product-list tr')
                                .removeClass('active')
                                .find('input[type="checkbox"]')
                                .prop('checked', false);

                            updateCount(0);
                            updateSelectVisibleButtonLabel(false);
                        } else {
                            alert = 'error';
                        }

                        if (data.code === 2) {
                            emailErrors.text(data.message);
                        } else {
                          addAlert(alert, data.message);
                          modal.modal('hide');

                          $('html, body').animate({
                            scrollTop: 0
                          }, 1000);
                        }
                    }
                )
                .always(function() {
                    btn.prop('disabled', false);
                });
        });
    });

    $(window).resize(function () {
        setEqualHeight('#panel-package .col-title');
    });

    $(window).load(function () {
        // getScrollTop();
        // toggleSubmitBoxState();
        setEqualHeight('#panel-package .col-title');
    });

    function filterProducts() {
        var products = [];
        var title = filterTitle.val().trim().toLocaleLowerCase();

        var filters = getFilters();

        var filteredItems = items;

        console.log(title);

        if (title.length) {
            filteredItems = items.filter(function() {
                return $(this).children('td:nth-child(2)').text().trim().toLocaleLowerCase().indexOf(title) >= 0;
            });
        }

        if (filters.length) {
            $.each(filters, function(k, filterId) {
                $.each(ids[filterId], function(l, id) {
                    products.push(id);
                });
            });

            filteredItems = filteredItems.filter(function() {
                return $.inArray($(this).data('id'), products) >= 0;
            });
        }

        items
            .show()
            .not(filteredItems)
            .hide();

        updateSelectVisibleButtonLabel();
    }

    function getFilters() {
        return $.map(filterSelect.find('option[value]:selected'), function(o) { return o.value; });
    }

    function addAlert(type, message) {
        var div = $('<div/>');

        div.addClass('alert');
        div.addClass('alert-' + type);

        div.html(message);

        alerts.html(div);
    }

    function updateCount(count, append) {
        if (append === true) {
            count = parseInt(counter.text()) + count;
        }

        if (count > 0) {
          $('#generate-zip').prop('disabled', false);
        } else {
          $('#generate-zip').prop('disabled', true);
        }

        counter.html(count);
    }
}

function panelFiles(downloadLabel, notificationTitle, notificationMsg, checkInterval) {
    if (('Notification' in window) && Notification.permission !== 'granted' && Notification.permission !== 'denied') {
        Notification.requestPermission();
    }

    if (checkInterval === undefined) {
        checkInterval = 15000;
    }

    $(document).ready(function() {
        $('#panel-files .toggle-details').click(function () {
            $(this).children('span').toggleClass('visible');
            $(this).children('i').toggleClass('rotated');
            $(this).next().slideToggle();
        });

        setTimeout(checkForUpdates, checkInterval);
    });

    function checkForUpdates() {
        //<tr data-hash="{{ item.hash }}" {% if not item.generatedAt and not item.deleted %}data-update="true"{% endif %}>
        var items = $('#panel-files table tr[data-id][data-update="true"]');

        if (!items.length) {
            return;
        }

        var idList = [];
        items.each(function(k, v) {
            idList.push($(v).data('id'));
        });

        $.get(
            Routing.generate('app_press_check_updates'),
            {'id' : idList},
            function(data) {
                if (data.length > 0) {
                    $.each(data, function(k, v) {
                        var item = items.filter('[data-id="' + v.id + '"]');

                        if (item.length > 0) {
                            item.attr('data-update', null);

                            var route = Routing.generate('app_press_download', {
                                hash: v.hash
                            });

                            item.find('.button-cell').html('<a href="' + route + '">' + downloadLabel + '</a>');
                            item.find('.date-cell').text(v.generatedAt);
                        }
                    });

                    updateNotification();
                }
            }
        );

        setTimeout(checkForUpdates, checkInterval);
    }

    function updateNotification() {
        if (('Notification' in window) && Notification.permission === 'granted' && notificationTitle !== undefined) {
            var options = {};

            if (notificationMsg !== undefined) {
                options.body = notificationMsg;
            }

            new Notification(notificationTitle, options);
        }
    }
}
